<template>
  <div class="product-table">
    <form class="product-table__head">
      <input-sort
        v-model="sortByName"
        v-on:input="sortProductListByName"
        name="name"
      >
        <div
          class="product-table__cell sort"
          v-bind:class="{ selected: sortByName ? 'selected' : '' }">
          Наименование</div>
      </input-sort>
      <div class="product-table__cell">Производитель</div>
      <div class="product-table__cell">Ед. измерения</div>
    </form>
    <div class="product-table__body-mobile">
      <button
        class="product-table__body-mobile__button-row"
        type="button"
        v-for="({
          id,
          name,
          manufacturer,
          unit,
        }) in productList"
        v-bind:key="id"
        v-on:click="onEditProduct(id)">
        <dl class="product-table__body-mobile__row">
          <dt>Наименование</dt>
          <dd>{{ name }}</dd>
          <dt>Производитель</dt>
          <dd>{{ manufacturer }}</dd>
          <dt>Ед. измерения</dt>
          <dd>{{ unit }}</dd>
        </dl>
      </button>
    </div>
    <div
      v-if="!this.isProductListEmpty && !this.isAwaitRequest"
      class="product-table__body"
    >
      <div
        class="product-table__row"
        v-for="({
          id,
          name,
          manufacturer,
          unit,
        }) in productList"
        v-bind:key="id">
        <button
          class="product-table__cell name"
          data-label="Наименование"
          title="Открыть"
          type="button"
          v-on:click="onEditProduct(id)">
          {{ name }}
        </button>
        <div
          data-label="Производитель"
          class="product-table__cell">{{ manufacturer }}</div>
        <div
          data-label="Ед. измерения"
          class="product-table__cell">{{ unit }}</div>
        <div
          data-label="Редактировать"
          class="product-table__cell"
        >
          <button
            class="product-table__icon-edit"
            type="button"
            v-on:click="onEditProduct(id)" />
        </div>
        <div
          data-label="Удалить"
          class="product-table__cell">
          <button
            class="product-table__icon-delete"
            type="button"
            v-on:click="onDeleteProduct(id)" />
        </div>
      </div>
    </div>
    <div
      v-else-if="!isAwaitRequest"
      class="product-table__message"
    >
      <slot name="empty-result" />
    </div>
  </div>
</template>
<script>
import InputSort from '@/components/InputSort.vue';

/**
 * @description Таблица товаров.
 * @type {any}
 */
export default {
  created() {
    this.sortByName = this.sort.type === 'name' ? this.sort.order : '';
  },
  data() {
    return {
      sortByName: '',
    };
  },
  components: {
    InputSort,
  },
  computed: {
    /**
     * @description Является ли список товаров пустым.
     * @returns {boolean}
     */
    isProductListEmpty() {
      return !Object.keys(this.productList).length;
    },
  },
  methods: {
    /**
     * Сортировать список товаров по наименованию.
     */
    sortProductListByName() {
      this.$emit('sort-product-list', {
        type: 'name',
        order: this.sortByName,
      });
    },
    /**
     * @description Обработать удаление товара.
     * @param {number} id Идентификатор товара.
     * @returns {void}
     */
    onDeleteProduct(id) {
      this.$emit('delete-product', id);
    },
    /**
     * @description Обработать редактирование товара.
     * @param {number} id Идентификатор товара.
     * @returns {void}
     */
    onEditProduct(id) {
      this.$emit('edit-product', id);
    },
  },
  props: {
    /**
     * @description Список товаров.
     * @type {any[]}
     */
    productList: { type: Array, required: true },
    /**
     * @description Ожидание завершения запроса.
     * @type {boolean}
     */
    isAwaitRequest: { type: Boolean, required: true },
    /**
     * @description Тип сортировки
     * @type {Object}
     */
    sort: { type: Object, default: () => ({ type: '', order: '' }) },
  },
};
</script>
<style lang="scss">

.product-table {
  counter-reset: counterEmployees;
  margin: 0;
  overflow: auto;
  &__body-mobile {
    display: none;
    flex-direction: column;
    gap: 10px;
    &__button-row {
      &:nth-child(odd) {
        background-color: var(--fill-color);
      }
    }
    &__row {
      display: grid;
      font-size: 12px;
      grid-template-columns: auto 1fr;
      justify-items: flex-end;
      align-items: center;
      gap: 5px;
      padding: 5px;
      & > dt {
        justify-self: flex-start;
      }
      & > dd {
        text-align: right;
      }
    }
  }
  &__head,
  &__row {
    display: grid;
    grid-template-columns:
      minmax(300px, 1fr)
      repeat(2, minmax(150px, 200px))
      repeat(2, 43px);
    align-items: center;
    font-size: 14px;
    line-height: 17px;
  }
  &__head {
    font-weight: 700;
    border-bottom: 2px solid #0489e0;
  }
  &__row {
    border-bottom: 1px solid #eaeff3;
    padding: 0;
    &:hover {
      background: #eaeff3;
    }
  }
  &__cell {
    padding: 12px 8px;
    transition: color var(--animate-duration);
    overflow: hidden;
    &.sort {
      text-align: left;
      cursor: pointer;
      display: flex;
      align-items: center;
      &:after {
        content: '';
        background-image: url("@/assets/img/checked/checked-grey.svg");
        background-repeat: no-repeat;
        background-size: contain;
        background-position: center;
        width: 10px;
        height: 10px;
        margin: 0 0 0 5px;
      }
      &:hover {
        text-decoration: none;
      }
      &.selected {
        color: var(--action-color);
      }
    }
    .theme--light.v-icon:focus:after {
      opacity: 0;
    }
    &.name {
      display: inline-flex;
      align-items: center;
      gap: 10px;
      text-align: left;
      padding: 0;
      button:first-child {
        text-align: left;
      }
      &:hover {
        cursor: pointer;
        color: var(--action-color);
      }
    }
    &.success,
    &.fail,
    &.none {
      display: flex;
      align-items: center;
    }
    &.success:before,
    &.fail:before,
    &.none:before {
      content: '';
      height: 20px;
      margin-right: 10px;
      width: 20px;
      background-repeat: no-repeat;
      background-position: center;
      background-size: contain;
    }
    &.success {
      background: #E4FFEC !important;
      &:before {
        background-image: url("@/assets/img/checked/all-checked-green.svg");
      }
    }
    &.fail {
      background: #FFECEC;
      &:before {
        background-image: url("@/assets/img/exit-red.svg");
      }
    }
    &.none:before {
      height: 6px;
      width: 6px;
      background: #ABB1A3;
      border-radius: 50%;
      margin: 0 10px 0 6px;
    }
  }
  &__cell.cda-completeness {
    font-size: 0px;
    &::after {
      font-size: 1rem;
    }
    &.empty::after {
      content: '-';
    }
    &.full::after {
      content: '+';
    }
    &.unknown::after {
      content: '?';
    }
  }
  &__message {
    text-align: center;
    padding-top: 40px;
    font-size: 24px;
    display: flex;
    justify-content: center;
  }
  &__icon {
    &-edit {
      display: block;
      background-image: url("@/assets/img/pen-grey.svg");
      background-size: contain;
      background-repeat: no-repeat;
      width: 14px;
      height: 14px;
      padding: 0;
      margin: 0;
      cursor: pointer;
      &:hover {
        background-image: url("@/assets/img/pen-blue.svg");
      }
    }
    &-delete {
      display: block;
      background-image: url("@/assets/img/exit-grey.svg");
      background-size: contain;
      background-repeat: no-repeat;
      width: 12px;
      height: 12px;
      cursor: pointer;
      &:hover {
        background-image: url("@/assets/img/exit-blue.svg");
      }
    }
    &-download {
      display: block;
      background-image: url("@/assets/img/download-file.svg");
      background-size: contain;
      background-repeat: no-repeat;
      width: 20px;
      height: 20px;
      padding: 0;
      margin: 0;
      cursor: pointer;
    }
    &-copy {
      display: block;
      background-image: url("@/assets/img/copy-grey.svg");
      background-size: contain;
      background-repeat: no-repeat;
      width: 14px;
      min-width: 14px;
      height: 14px;
      min-height: 14px;
      padding: 0;
      margin: 0;
      cursor: pointer;
      &:hover {
        background-image: url("@/assets/img/copy-blue.svg");
      }
    }
  }
}
@media screen and (max-width: 1400px) {
  .product-table {
    &__head,
    &__row {
      grid-template-columns: 1.4fr repeat(2, 1fr) repeat(2, 43px);
      font-size: 12px;
      line-height: 17px;
    }
  }
}
@media screen and (max-width: 1100px) {
  .product-table {
    &__head {
      display: none;
    }
    &__row {
      grid-template-columns: 1fr;
      grid-gap: 10px;
      min-width: auto;
      margin-bottom: 10px;
      padding-block: 10px;
    }
    &__cell {
      display: flex;
      justify-content: space-between;
      text-align: right;
      padding: 0;
      &.name {
        text-align: right;
      }
    }
    &__cell::before {
      content: attr(data-label);
      font-weight: 700;
      margin-right: 20px;
      font-size: 12px;
    }
  }
}
@media screen and (max-width: 480px) {
  .product-table__body {
    display: none;
    &-mobile {
      display: flex;
    }
  }
}
</style>
